import React, { useState, useRef, useEffect } from 'react';
import "../../../styles/Auth/tax.css";
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import { getData, postData, deleteData, putData } from '../../../webService/webservice.js';
const TaxSettings = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isAddTax = location.pathname === '/settings/tax/add';
    const role = sessionStorage.getItem("role");
    const adminStoreId = sessionStorage.getItem("storeId");
    const [taxes, setTaxes] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editTaxId, setEditTaxId] = useState(null);
    const [taxToDelete, setTaxToDelete] = useState(null);
    const [storeId, setStoreId] = useState(role === "Admin" ? adminStoreId : "");
    const token = sessionStorage.getItem("Token");
    const [limit, setLimit] = useState(5);
    const [formData, setFormData] = useState({
        name: '',
        percentage: '',
        ...(role === "SuperAdmin" && { storeId }),
    });
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'SL',
        'Name',
        'Percentage',
        'Status',
        'Action',
    ];
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };
    const handleOpen = (taxId) => {
        setTaxToDelete(taxId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setTaxToDelete(null);
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };
    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = sessionStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                console.log('API Full Response:', data);
                const results = data?.data?.[0]?.paginatedResults || [];
                setStores(results);

            } catch (error) {
                console.error("Failed to load sub categories", error);
            }
        };
        fetchStores();
    }, []);

    useEffect(() => {
        const storedStoreId = sessionStorage.getItem("storeId");
        if (storedStoreId && stores.length > 0) {
            const matchedStore = stores.find((store) => store._id === storedStoreId);
            if (matchedStore) {
                setFormData((prev) => ({
                    ...prev,
                    storeId: matchedStore._id,
                    storeName: matchedStore.storeName,
                }));
            }
        }
    }, [stores]);

    const handleItemsPerPageChange = (e) => {
        const newLimit = Number(e.target.value);
        setLimit(newLimit);
        setCurrentPage(1);
    };
    const handleAddTax = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem("Token");
            const taxData = {
                storeId: formData.storeId,
                name: formData.name,
                percentage: formData.percentage
            };
            console.log("Sending tax data:", taxData);

            const response = await postData('tax/', taxData, token);

            toast.success(response.message || 'tax added successfully');
            setFormData({
                name: '',
                percentage: '',
            });
            navigate("/settings/tax");
            triggerRefresh();

        } catch (error) {
            console.error('Add Tax Error:', error);
            toast.error(error.message || 'Add tax Failed');
        }
    };
    useEffect(() => {
        fetchTaxes(currentPage, limit, token);
    }, [currentPage, limit, refreshKey]);

    const fetchTaxes = async (page, limit) => {
        const params = {
            page,
            limit,
        }
        try {
            setLoading(true);
            const response = await getData('tax/taxes', params, token); // Your API route
            const resultsWrapper = response?.data;
            const TaxList = resultsWrapper?.results || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setTaxes(TaxList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch categories");
        } finally {
            setLoading(false);
        }
    };
    const handleDeleteTax = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem('Token');
            const response = await deleteData(`tax/tax/${taxToDelete}`, token);
            toast.success(response.message || "Tax deleted successfully");
            setTaxToDelete(null);
            fetchTaxes(currentPage, limit);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Tax");
        }
    }
    const handleUpdateTax = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem("Token");
            const updatedTaxData = {
                name: formData.name,
                percentage: formData.percentage,
                storeId: formData.storeId
            };

            console.log("Updating Tax with data:", updatedTaxData);

            const response = await putData(`tax/tax/${editTaxId}`, updatedTaxData, token);

            toast.success(response.message || 'Tax updated successfully');

            // Step 4: Reset form and close modal
            setFormData({
                name: '',
                percentage: '',
                storeId: ''
            });
            setIsPopupMode(false);
            setIsEditMode(false);
            fetchTaxes(currentPage, limit);
            triggerRefresh();
        } catch (error) {
            toast.error("Error updating Tax.");
        }
    };
    return (
        <div className='tax-layout'>
            <div className='tax-content'>
                <main className='tax-main'>
                    {isAddTax ? (
                        <div className='add-tax-form'>
                            <h3>Tax Settings</h3>
                            <form className='tax-form'>
                                <div className='Tax-form-row'>
                                    {role === "SuperAdmin" ? (
                                        <div className="tax-form-group">
                                            <label className="input-label">Store Name</label>
                                            <select
                                                id="storeId"
                                                className="Tax-input"
                                                value={formData.storeId || ""}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({ ...prev, storeId: e.target.value }))
                                                }
                                            >
                                                <option value="">Select Store</option>
                                                {stores.map((store) => (
                                                    <option key={store._id} value={store._id}>
                                                        {store.storeName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    ) : (
                                        <input
                                            type="hidden"
                                            value={adminStoreId}
                                            readOnly
                                            name="storeId"
                                        />
                                    )}
                                    <div className='tax-form-group'>
                                        <label htmlFor="name" className="input-label">
                                            Tax Name
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter tax name"
                                            required
                                            className="Tax-input"
                                            value={formData.name}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, name: e.target.value }))
                                            }
                                        />
                                    </div>
                                    <div className='tax-form-group'>
                                        <label htmlFor='percentage' className='input-label'>
                                            Percentage
                                        </label>
                                        <input
                                            type="number"
                                            placeholder="Enter percentage"
                                            required
                                            className="Tax-input"
                                            value={formData.percentage}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, percentage: e.target.value }))
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="Tax-buttons">
                                    <button className="add-Tax-button" type="submit" onClick={handleAddTax}>
                                        add Tax
                                    </button>
                                    <button className="cancel-Tax-button" onClick={() => navigate('/settings/tax')}>
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <div className='tax-widgets'>
                                <div className="tax-widgets-header">
                                    <h3>Tax</h3>
                                </div>
                                <div className="add-tax-buttons">
                                    <button className="add-btn-tax" onClick={() => navigate('/settings/tax/add')}>+ Add New</button>
                                </div>
                            </div>
                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                overflow: 'auto',
                                maxHeight: '400px',
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-product-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-product-head">
                                        <TableRow sx={{ backgroundColor: '#F7EAE2' }}>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',

                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {taxes.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={5}>
                                                    <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                        No Tax found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            taxes.map((tax, index) => (
                                                <TableRow key={tax._id}>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                    </TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{tax.name}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{tax.percentage}</Typography></TableCell>
                                                    <TableCell>
                                                        <Button
                                                            variant="contained"
                                                            sx={{
                                                                backgroundColor: tax.isActive ? '#28A745' : '#C10000',
                                                                color: '#ffffff',
                                                                fontWeight: 600,
                                                                padding: '4px 8px',
                                                                borderRadius: '10px',
                                                                width: '90px',
                                                                maxHeight: '90px',
                                                                textTransform: 'none',
                                                                '&:hover': {
                                                                    backgroundColor: tax.isActive ? '#218838' : '#a10000',
                                                                },
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                margin: '0 auto'
                                                            }}
                                                        >
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                            <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                setFormData({
                                                                    name: tax.name || '',
                                                                    percentage: tax.percentage || '',
                                                                    storeId: tax.storeId || ''
                                                                });
                                                                setEditTaxId(tax._id);
                                                                setIsPopupMode(true);
                                                                setIsEditMode(true);
                                                            }} />
                                                            <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000' }}
                                                                onClick={() => handleOpen(tax._id)}
                                                            />
                                                        </Box>

                                                    </TableCell>
                                                </TableRow>

                                            ))
                                        )}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="tax-bottom">
                                <div className="tax-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="tax-section showing-range">
                                    {`Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`}
                                </div>
                                <div className="tax-section spacer"></div>
                                <div className="tax-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setFormData({
                                                    name: '',
                                                    percentage: '',
                                                    storeId: ''
                                                });
                                            }}
                                        />
                                        <div className="popup-form">
                                            <h2 className="popup-title">
                                                {isEditMode ? "Edit Tax" : "Add Tax"}
                                            </h2>
                                            <form className="popup-form-body" onSubmit={handleUpdateTax}>
                                                <div className="tax-form-group-row">
                                                    <div className="tax-form-group">
                                                        <label htmlFor="name">Name</label>
                                                        <input
                                                            type="name"
                                                            id="name"
                                                            className="Tax-input"
                                                            value={formData.name}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    name: e.target.value,
                                                                }))
                                                            }
                                                        />
                                                    </div>
                                                    {role === "SuperAdmin" ? (
                                                        <div className="tax-form-group">
                                                            <label htmlFor="storeId" className="input-label">
                                                                Store
                                                            </label>
                                                            <select
                                                                id="storeId"
                                                                className="Tax-input"
                                                                value={formData.storeId || ""}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({ ...prev, storeId: e.target.value }))
                                                                }
                                                            >
                                                                <option value="">Select Store</option>
                                                                {stores.map((store) => (
                                                                    <option key={store._id} value={store._id}>
                                                                        {store.storeName}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    ) : (
                                                        <input
                                                            type="hidden"
                                                            value={adminStoreId}
                                                            readOnly
                                                            name="storeId"
                                                        />
                                                    )}
                                                    <div className="tax-form-group">
                                                        <label htmlFor="percentage">Percentage</label>
                                                        <input
                                                            type="number"
                                                            id="percentage"
                                                            maxLength={2}
                                                            className="Tax-input"
                                                            title="percentage must be exactly 2 digits"
                                                            value={formData.percentage}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Allow only digits and max 12 characters
                                                                if (/^\d{0,2}$/.test(value)) {
                                                                    setFormData((prev) => ({ ...prev, percentage: value }));
                                                                }
                                                            }}
                                                            onBlur={() => {
                                                                if (formData.percentage.length !== 2) {
                                                                    alert("Percentage must be exactly 2 digits");
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-actions">
                                                    <button type="submit" className="btn-primary">
                                                        {isEditMode ? "Update Product" : "Add Product"}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn-secondary"
                                                        onClick={() => setIsPopupMode(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {limit > 5 && taxes.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more taxes
                                    </Typography>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={modalStyle}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center' }}>
                                        Confirm Delete?
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: 14, textAlign: 'center' }}>
                                        Are you sure you want to delete this tax?
                                    </Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                                        <Button variant="contained" color="error" sx={{ background: 'linear-gradient(#A16A70, #D98484)' }} onClick={handleDeleteTax}>
                                            Yes, Delete
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={handleClose} sx={{ background: 'background-color: #D9D9D9', color: '#000' }}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    )}

                </main>
            </div>
        </div>
    );
};

export default TaxSettings;